import type { Study, ConcentrationTimePoint } from '@bioavail/shared-types';
import { createArm, createStudy } from '../factory';
import {
  RouteOfAdministration as ROA,
  ArmRole as AR,
  DoseUnit as DU,
  ConcentrationUnit as CU,
  TimeUnit as TU,
  CalculationMode as CM,
  AucInterval as AI,
} from '@bioavail/shared-types';

/**
 * Worked example: Relative F — two oral arms with unequal doses (test 50mg vs ref 25mg).
 */
export function relativeFExample(): Study {
  const testPoints: ConcentrationTimePoint[] = [
    { time: 0.5, concentration: 120, isBlq: false },
    { time: 1, concentration: 280, isBlq: false },
    { time: 2, concentration: 360, isBlq: false },
    { time: 4, concentration: 240, isBlq: false },
    { time: 6, concentration: 140, isBlq: false },
    { time: 8, concentration: 78, isBlq: false },
    { time: 12, concentration: 22, isBlq: false },
    { time: 16, concentration: 5.8, isBlq: false },
    { time: 24, concentration: 0.4, isBlq: false },
  ];

  const refPoints: ConcentrationTimePoint[] = [
    { time: 0.5, concentration: 70, isBlq: false },
    { time: 1, concentration: 165, isBlq: false },
    { time: 2, concentration: 210, isBlq: false },
    { time: 4, concentration: 140, isBlq: false },
    { time: 6, concentration: 82, isBlq: false },
    { time: 8, concentration: 45, isBlq: false },
    { time: 12, concentration: 12.5, isBlq: false },
    { time: 16, concentration: 3.2, isBlq: false },
    { time: 24, concentration: 0.2, isBlq: false },
  ];

  return createStudy({
    name: 'Example — Relative F (Tablet 50mg vs Capsule 25mg)',
    mode: CM.Relative,
    aucInterval: AI.ZeroToInf,
    arms: [
      createArm({
        id: 'arm-test',
        label: 'Test (Tablet 50 mg)',
        route: ROA.Oral,
        role: AR.Test,
        dose: 50,
        doseUnit: DU.Mg,
        concentrationUnit: CU.NgPerMl,
        timeUnit: TU.Hour,
        dataPoints: testPoints,
      }),
      createArm({
        id: 'arm-ref',
        label: 'Reference (Capsule 25 mg)',
        route: ROA.Oral,
        role: AR.Reference,
        dose: 25,
        doseUnit: DU.Mg,
        concentrationUnit: CU.NgPerMl,
        timeUnit: TU.Hour,
        dataPoints: refPoints,
      }),
    ],
  });
}
